import { Supplier } from '@/models/Supplier';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<SupplierAutocomplete>({})
export default class SupplierAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Supplier' })
  protected label!: string;

  @Prop({ default: () => new Supplier() })
  protected model!: Supplier;

  @Prop({ default: 'Agent D' })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
